<template>
    <span v-if="isNecessary">
        <template v-if="isVisible">
            {{ text }}
            <a class="toggle-text-link" @click.stop="toggle">
                {{ $t('global_viewLess') }}
            </a>
        </template>
        <template v-else>
            {{ lessText }}
            <a class="toggle-text-link" @click.stop="toggle">
                {{ $t('global_viewMore') }}
            </a>
        </template>
    </span>
    <span v-else>
        {{ text }}
    </span>
</template>

<script>
    export default {
        name: 'ReadMore',

        props: {
            max: { type: Number },
            desktop: { type: Number },
            mobile: { type: Number },
            mobileResolution: { type: Number, default: 767 },
        },

        data() {
            return {
                isVisible: false,
            };
        },

        computed: {
            maxLength() {
                // Checking $resize will make the whole expression reactive, updating it on resize
                return this.$resize && ((this.$mq.above(this.mobileResolution) ? this.desktop : this.mobile) || this.max || 0);
            },

            text() {
                return this.$slots.default[0].text.trim();
            },

            isNecessary() {
                return this.text.length >= this.maxLength;
            },

            lessText() {
                return this.text.substring(0, this.maxLength) + this.$t('global_ellipsis');
            },
        },

        methods: {
            toggle() {
                this.isVisible = !this.isVisible;
            },
        },
    }
</script>
